module.exports = __webpack_public_path__ + "img/tu05.07440dce.png";